import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Pagination from '../../../components/Pagination';
import Loader from '../../../components/Loader';
import EditableTable from "./UserAccountTable";
import Modal from "../../../components/Modal"
import ChangeLog from "../../../components/ChangeLog";
import {fetchUserList, fetchUserType, updateUserList} from "../../../slices/userSlice"
import { fetchCountryList } from "../../../slices/LocationSlice/countrySlice";
import { fetchGenderList } from "../../../slices/genderSlice";
import AddUser from './AddUser'



function UserList() {
  const dispatch = useDispatch();
  const { users, userTypes, status, error } = useSelector((state) => state.userList);

    const {countryList} = useSelector((state) => state.countryList);
    const {genderList} = useSelector((state)=>state.genderList);
  
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(users?.result) ? users?.result?.slice(indexOfFirstItem, indexOfLastItem) : [];
  const totalPages = Array.isArray(users?.result) ? Math.ceil(users?.result?.length / itemsPerPage) : 0;
  const headers = users?.result?.length > 0 ? Object.keys(users?.result[0]).filter((key) => key !== 'id') : [];
  const editableFields = ['title','status','is_active','name','email','gender','country','dateOfBirth','accessType','is_emailVerified']; // Define editable fields

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog,setCurrentLog] = useState([]);
  const [addPageDis, setAddPageDis] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);


  useEffect(() => {
    dispatch(fetchUserList());
    dispatch(fetchUserType());
    dispatch(fetchCountryList());
    dispatch(fetchGenderList());
  }, [dispatch]);

  // if (status === "loading") {
  //   return (
  //     <div className="w-full">
  //       <Loader />
  //     </div>
  //   );
  // }

  // if (status === "failed") {
  //   return <div>Error: {error}</div>;
  // }

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = users?.result?.find((user) => user.id === rowId);
    setEditedData(rowData);
  };


  const handleSave = async () => {
    const { id, email, name, dateOfBirth, is_active, gender, country, is_emailVerified} = editedData;
    // const gender = genderList?.option_List?.filter((f)=>f.title === editedData.gender)[0].id;
    // const country = countryList?.result?.filter((f)=>f.title === editedData.country)[0].id;
    const accessType = userTypes?.result?.filter((f)=>f.title === editedData.accessType)[0].id;
    console.log(is_emailVerified)
    const updatedData = {id, email, name, dateOfBirth, is_active, country, gender,accessType, is_emailVerified};

    const resp = await dispatch(updateUserList(updatedData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchUserList());
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field,val) => {
      if(['status','active','is_active','is_emailVerified'].includes(field)){
        setEditedData((prev) => ({
          ...prev,
          [field]:!val,
        }));
      }else{
        setEditedData((prev) => ({
          ...prev,
          [field]:e.target.value,
        }));
      }
  };

  const handleLog = (id)=>{
    const logData = users.Change_Log.filter((f)=>f.id===id)[0]?.oldTrack;
    setCurrentLog(logData)
    openModal()
  }

  return (
    <div className=" w-full flex flex-col items-center p-6">
      {/* <h1 className="text-xl m-4 font-semibold">User Account</h1> */}
    <div className="w-full flex items-center flex-col">

      <div className="max-w-[100%] overflow-auto">
      <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleChange={handleChange}
        handleLog={handleLog}
        editableFields={editableFields} // Pass editable fields
        userTypes={userTypes}
        countryList={countryList}
        genderList={genderList}
        fetchUserList={fetchUserList}
      />
      </div>

      
      
      <div className="flex mt-4 items-center justify-between w-11/12">

<Pagination
  currentPage={currentPage}
  setCurrentPage={setCurrentPage}
  totalPages={totalPages}
/>

<button onClick={()=>setAddPageDis(true)} className="activeBtn text-sm text-white  py-1 px-2 rounded" >
            + Add User
          </button>

    </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog}/>}
      />


     <Modal
        isOpen={addPageDis}
        onClose={()=>setAddPageDis(false)}
        title="Add User"
        content={<AddUser userTypes={userTypes} countryList={countryList} genderList={genderList} />}
      />



    </div>
    </div>
  );
}

export default UserList;